import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { HiOutlineChevronLeft } from 'react-icons/hi';
import { useAuth } from '../context/AuthContext';

/**
 * The GP module's own second-level navigation, restyled to reception's
 * module-shell convention (the .gpm-* classes in gp.css) instead of the
 * standalone app's dark Tailwind sidebar — same header/sidebar/content chrome as
 * the rest of Prime Office, so the module reads as part of it rather than an
 * embedded separate app. The header says "Sales Analysis", the card's UI title.
 *
 * `gp-viewport overflow-hidden` (not the standalone's `min-h-screen`) is what keeps
 * this shell full-height while its content scrolls internally.
 */
const navItems = [
    { to: '/gp-report', label: 'Dashboard', end: true },
    { to: '/gp-report/gp-analysis', label: 'GP Analysis', approveOnly: true },
    { to: '/gp-report/gp-targets', label: 'GP Targets', approveOnly: true },
    { to: '/gp-report/brief-report', label: 'Brief Report' },
    { to: '/gp-report/month-analysis', label: 'Month-wise Analysis' },
    { to: '/gp-report/price-checker', label: 'Price Checker' },
    { to: '/gp-report/customers', label: 'Customers' },
    { to: '/gp-report/products', label: 'Products' },
    { to: '/gp-report/salesmen', label: 'Salesmen' },
    { to: '/gp-report/sales-upload', label: 'Sales Upload' },
    { to: '/gp-report/sales-data', label: 'Sales Data Management', adminOnly: true },
    { to: '/gp-report/api-keys', label: 'API Keys', adminOnly: true },
];

export default function Layout() {
    const { isAdmin, canViewGP } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="gp-viewport gpm-shell">
            <header className="gpm-header">
                <div className="gpm-header-left">
                    <button className="gpm-back-btn" onClick={() => navigate('/purpose-selection')}>
                        <HiOutlineChevronLeft size={20} />
                    </button>
                    <div className="gpm-header-title">
                        <h1>Sales Analysis</h1>
                        <span>Module</span>
                    </div>
                </div>
            </header>

            <div className="gpm-body">
                <aside className="gpm-sidebar">
                    {navItems
                        .filter((item) => (!item.adminOnly || isAdmin) && (!item.approveOnly || canViewGP))
                        .map(({ to, end, label }) => (
                            <NavLink
                                key={to}
                                to={to}
                                end={end}
                                className={({ isActive }) => `gpm-nav-item ${isActive ? 'active' : ''}`}
                            >
                                <span>{label}</span>
                            </NavLink>
                        ))}
                </aside>
                <main className="gpm-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
